export default __webpack_public_path__ + "static/media/bienvenida.6a994845.png";